import { Flex } from 'antd';
import styles from './create-channel.module.scss';
import { ChannelCreatePage } from '@modules/channels/ui/channel-create/channel-create';

export const CreateChannel = () => (
  <Flex className={styles.root}>
    <ChannelCreatePage />
  </Flex>
);
